import { addHours, differenceInHours } from 'date-fns';
import { ProgressionModelDatePoint } from 'features/wildfires/wildfire.types';
import { TFunction } from 'i18next';

export const generateDateRange = (input: {
  t: TFunction;
  startDate: Date;
  endDate: Date;
  datePoints: number;
}): ProgressionModelDatePoint[] => {
  const { t, startDate, endDate, datePoints } = input;

  const totalHours = differenceInHours(endDate, startDate);
  const intervalHours = totalHours / (datePoints - 1);

  const dateRange = Array.from({ length: datePoints }, (_, i) => {
    const date =
      i === datePoints - 1 ? endDate : addHours(startDate, intervalHours * i);
    return {
      date,
      label: t('wildfireProgressionModel.hourLabel', {
        hour: i * intervalHours,
      }),
      timestamp: Math.floor(date.getTime() / 1000),
    };
  });

  return dateRange;
};
